/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CreateZoneFromJSON, CreateZoneToJSON } from './CreateZone';

/**
 * Payload to add a new zone to a block in a view
 * @export
 * @interface AddZoneToView
 */

/**
 * Check if a given object implements the AddZoneToView interface.
 */
export function instanceOfAddZoneToView(value) {
  if (!('zone' in value) || value['zone'] === undefined) return false;
  if (!('blockRID' in value) || value['blockRID'] === undefined) return false;
  return true;
}
export function AddZoneToViewFromJSON(json) {
  return AddZoneToViewFromJSONTyped(json, false);
}
export function AddZoneToViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'zone': CreateZoneFromJSON(json['zone']),
    'blockRID': json['blockRID'],
    'viewId': json['viewId'] == null ? undefined : json['viewId'],
    'blockId': json['blockId'] == null ? undefined : json['blockId'],
    'containerRID': json['containerRID'] == null ? undefined : json['containerRID'],
    'plugins': json['plugins'] == null ? undefined : json['plugins']
  };
}
export function AddZoneToViewToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'zone': CreateZoneToJSON(value['zone']),
    'blockRID': value['blockRID'],
    'viewId': value['viewId'],
    'blockId': value['blockId'],
    'containerRID': value['containerRID'],
    'plugins': value['plugins']
  };
}